import { jsxs, jsx } from "react/jsx-runtime";
const IconHeartSvg = ({ title, titleId, ...props }) => /* @__PURE__ */ jsxs(
  "svg",
  {
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 24 24",
    focusable: "false",
    fill: "currentColor",
    width: 16,
    height: 16,
    "aria-labelledby": titleId,
    ...props,
    children: [
      title ? /* @__PURE__ */ jsx("title", { id: titleId, children: title }) : null,
      /* @__PURE__ */ jsx("path", { d: "M12 22C10.444 22 1 15.535 1 8.5 1 4.916 3.916 2 7.5 2A6.5 6.5 0 0 1 12 3.815 6.5 6.5 0 0 1 16.5 2C20.084 2 23 4.916 23 8.5 23 15.535 13.557 22 12 22Zm.125-1.987Zm-.25 0ZM7.5 4A4.505 4.505 0 0 0 3 8.5c0 5.491 7.441 10.862 9 11.47 1.559-.608 9-5.979 9-11.47C21 6.019 18.981 4 16.5 4c-1.46 0-2.838.717-3.682 1.919-.375.533-1.261.533-1.636 0A4.506 4.506 0 0 0 7.5 4Z" })
    ]
  }
);
export {
  IconHeartSvg
};
